<script>
import { layoutComputed, adminComputed } from "@/state/helpers";
import Vertical from "./vertical";
import Horizontal from "./horizontal";

export default {
    components: {
        Vertical,
        Horizontal,
    },
    data() {
        return {};
    },
    computed: {
        ...adminComputed,
        ...layoutComputed,
    },
    methods: {},
};
</script>

<template>
    <div>
        <vertical v-if="coreLoadingStatus && layoutType === 'vertical'" :layout="layoutType">
            <slot />
        </vertical>

        <Horizontal v-if="coreLoadingStatus && layoutType === 'horizontal'" :layout="layoutType">
            <slot />
        </Horizontal>
    </div>
</template>
